export default "__VITE_ASSET__Dc$dsD3v__"